module.exports = __webpack_public_path__ + "media/src/images/icons/finish/default-1757114221aedc6b22e6539e2bfc8da9.svg";